import { z } from 'zod';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { PlayerColor } from '../PlayerState.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
const mechanicSpecialBuildPhasePlayerStateSchema = z.object({
    isRequesting: z.union([
        z.literal(true),
        z.null()
    ]).exactOptional()
}).strict();
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
const mechanicSpecialBuildPhasePlayerStatesSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicSpecialBuildPhasePlayerStateSchema);
export const mechanicSpecialBuildPhaseStateSchema = z.object({
    lastPlayerToRollDice: z.union([
        z.enum(PlayerColor),
        z.null()
    ]).exactOptional(),
    playerStates: mechanicSpecialBuildPhasePlayerStatesSchema
}).strict();
export function validateMechanicSpecialBuildPhaseState(data) {
    return validateState(mechanicSpecialBuildPhaseStateSchema, data);
}
export const mechanicSpecialBuildPhaseStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicSpecialBuildPhaseStateSchema);
